(function () {
  'use strict';

  var DAY_MS = 86400000;
  var DEFAULT_ZONE = 'Europe/Amsterdam';

  function calendarDate(now, timeZone) {
    try {
      if (!(now instanceof Date) || !isFinite(now.getTime())) return null;
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone || DEFAULT_ZONE,
        calendar: 'gregory',
        numberingSystem: 'latn',
        year: 'numeric', month: 'numeric', day: 'numeric'
      }).formatToParts(now);
      var date = {};
      parts.forEach(function (part) {
        if (part.type === 'year' || part.type === 'month' || part.type === 'day') {
          date[part.type] = Number(part.value);
        }
      });
      if (!date.year || !date.month || !date.day) return null;
      return date;
    } catch (error) {
      return null;
    }
  }

  function dayNumber(year, month, day) {
    return Date.UTC(year, month - 1, day) / DAY_MS;
  }

  function blackFriday(year) {
    var firstWeekday = new Date(Date.UTC(year, 10, 1)).getUTCDay();
    var fourthThursday = 1 + ((4 - firstWeekday + 7) % 7) + 21;
    return fourthThursday + 1;
  }

  function holidayKey(now, timeZone) {
    var today = calendarDate(now, timeZone);
    if (!today) return 'special';
    var currentDay = dayNumber(today.year, today.month, today.day);
    var windows = [];

    function add(key, start, end, priority) {
      windows.push({ key: key, start: start, end: end, priority: priority || 20 });
    }

    // Generate adjacent years as well so the New Year window crosses December correctly.
    for (var year = today.year - 1; year <= today.year + 1; year += 1) {
      add('new_year', dayNumber(year - 1, 12, 27), dayNumber(year, 1, 7));
      add('valentine', dayNumber(year, 2, 7), dayNumber(year, 2, 14));
      add('happiness', dayNumber(year, 3, 13), dayNumber(year, 3, 20));
      add('friendship', dayNumber(year, 7, 23), dayNumber(year, 7, 30));
      add('halloween', dayNumber(year, 10, 24), dayNumber(year, 10, 31));
      add('kindness', dayNumber(year, 11, 6), dayNumber(year, 11, 13));
      var friday = blackFriday(year);
      // This is a shopping occasion label, not a deadline for the underlying offer.
      add('black_friday', dayNumber(year, 11, friday - 4), dayNumber(year, 11, friday + 3), 100);
      add('holiday', dayNumber(year, 12, 1), dayNumber(year, 12, 26), 10);
    }

    var active = windows.filter(function (window) {
      return currentDay >= window.start && currentDay <= window.end;
    }).sort(function (a, b) { return b.priority - a.priority; });
    if (active.length) return active[0].key;

    // Outside a celebration window, name the next occasion explicitly as upcoming.
    // Only the label changes; it does not create or imply a discount expiry date.
    var upcoming = windows.filter(function (window) {
      return window.start > currentDay;
    }).sort(function (a, b) {
      return a.start - b.start || b.priority - a.priority;
    });
    return upcoming.length ? 'upcoming_' + upcoming[0].key : 'special';
  }

  function campaignHolidayKey(now, timeZone, override, campaignYear) {
    if (override !== 'early_black_friday') return holidayKey(now, timeZone);
    var today = calendarDate(now, timeZone);
    if (!today) return 'special';
    var year = Number(campaignYear);
    if (!Number.isInteger(year) || today.year !== year) return holidayKey(now, timeZone);
    var currentDay = dayNumber(today.year, today.month, today.day);
    var friday = dayNumber(year, 11, blackFriday(year));
    var cyberMonday = friday + 3;
    if (currentDay > cyberMonday) return holidayKey(now, timeZone);
    return currentDay < friday ? 'early_black_friday' : 'black_friday';
  }

  // Pure helpers are exported only in Node; storefront pages receive no global API.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { calendarDate: calendarDate, holidayKey: holidayKey, blackFriday: blackFriday, campaignHolidayKey: campaignHolidayKey };
  }
  if (typeof document === 'undefined') return;

  function updateBar(bar, now) {
    var label = bar.querySelector('[data-kr-holiday-label]');
    var data = bar.querySelector('[data-kr-holiday-labels]') || document.querySelector('[data-kr-holiday-labels]');
    if (!label || !data) return;
    try {
      var labels = JSON.parse(data.textContent);
      if (!labels || Array.isArray(labels) || typeof labels !== 'object') return;
      var key = campaignHolidayKey(
        now,
        bar.getAttribute('data-time-zone') || DEFAULT_ZONE,
        bar.getAttribute('data-campaign-override'),
        bar.getAttribute('data-campaign-year')
      );
      var nextLabel = labels[key] || labels.special;
      if (typeof nextLabel === 'string' && label.textContent !== nextLabel) {
        label.textContent = nextLabel;
      }
    } catch (error) {
      // A missing or malformed settings block keeps the safe server-rendered label.
    }
  }

  function refresh() {
    var now = new Date();
    document.querySelectorAll('[data-kr-seasonal-offer]').forEach(function (bar) {
      updateBar(bar, now);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
  setInterval(function () {
    if (!document.hidden) refresh();
  }, 60000);
}());


